import React, { useEffect, useState } from 'react';
import GooglePlayButton from '../Button/GooglePlayButton';
import AppStoreButton from '../Button/AppStoreButton';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import { languageState } from '../../recoil/language/languageAtom';
import MainLogo from '../Common/MainLogo';

import { otpModalState } from '../../recoil/otp/otpModalAtom';
import useApi from '../../hooks/useApi';
import * as Sentry from '@sentry/react';

const AppLoginModalWrapper = () => {
  const [remainingTime, setRemainingTime] = useState(100);
  const { t } = useTranslation();
  const selectedLanguage = useRecoilValue(languageState);
  const [isOpen, setIsOpen] = useRecoilState(otpModalState);
  const [otpData, setOtpData] = useState(null);

  const api = useApi();

  const fetchOtpAuthCode = async () => {
    try {
      const response = await api.get('user/otp_auth/code');
      setOtpData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const checkOthAuthCode = async () => {
    const body = {
      otp_code: otpData?.otp_code,
    };

    try {
      const response = await api.post('user/otp_auth/code/check', body);
      const data = response.data;

      if (!data?.login) {
        return;
      }

      if (response.status === 200) {
        localStorage.setItem('access_token', data?.access_token);
        localStorage.setItem('exp', data?.exp);

        // 유저 정보 recoil 전역 관리 위해 저장
        const userInfo = {
          login: data?.login,
          membership: data?.membership,
          user_no: data?.user_no,
        };

        if (data) {
          // Sentry 유저 정보 전달
          Sentry.setUser({
            login: data?.login,
            membership: data?.membership,
            user_no: data?.user_no,
          });
        }

        localStorage.setItem('userInfo', JSON.stringify(userInfo));
      }
      setIsOpen(false);
      window.location.reload();
    } catch (error) {
      console.log('Login error:', error);
    }
  };

  const onClose = () => {
    setIsOpen(false);
  };

  useEffect(() => {
    fetchOtpAuthCode();
  }, []);

  useEffect(() => {
    // 모달에 새로 열릴 때 타이머 재설정
    if (isOpen) {
      setRemainingTime(100);
    }

    const timer = setInterval(() => {
      setRemainingTime((prevTime) => prevTime - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [isOpen]);

  useEffect(() => {
    let timer;

    if (isOpen && otpData) {
      timer = setInterval(() => {
        checkOthAuthCode();
      }, 3000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [isOpen, otpData]);

  return (
    <div className={`modal-all-wrapper ${isOpen ? 'is-show' : ''} is-small`}>
      <div className={'modal-dim-overlay'} onClick={onClose} />
      <div className={'modal-wrapper'}>
        <div className='modal-top-wrapper'>
          <div className='modal-left-wrapper'>
            <MainLogo typeSmaller={true} />
          </div>
          <div className='modal-right-wrapper'>
            <button type={'button'} className={'button-default modal-close-button'} onClick={onClose}>
              <i className={'icon icon-close-wh'} />
            </button>
          </div>
        </div>
        <div className='modal-content-wrapper component-custom-scroll'>
          <div className={'login-items-wrapper'}>
            <div className={'app-login-items-wrapper'}>
              <div className={'app-login-msg-group'}>
                <p className={'app-login-msg'}>{t('app_code_info_msg')}</p>
                <p className={'app-login-msg'}>
                  [{t('my_page')} &gt; {t('settings')} &gt; {t('web_login_code')}]
                </p>
              </div>
              <div className={'app-login-code-group'}>
                <p className={'app-login-code'}>{otpData?.otp_code ? otpData?.otp_code : 'Loading...'}</p>
              </div>
              <div className='app-login-status-group'>
                {remainingTime > 0 ? (
                  <p className={'app-login-status-txt'}>
                    {t('time_remaining')} {remainingTime}
                    {t('second')}
                    {selectedLanguage === 'en' ? remainingTime !== 1 && 's' : null}
                  </p>
                ) : (
                  <p className={'app-login-status-txt'}>{t('login_time_expire_msg')}</p>
                )}
              </div>
              <div className='app-login-button-group'>
                <GooglePlayButton buttonType={'mono'} />
                <AppStoreButton buttonType={'mono'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppLoginModalWrapper;
